import { Job } from "@models/job.model";
import { httpRequest } from "../../http";
import { JobSerializer } from "@models/serializers/jobSerializer";

export class CommandNetworkViewEngagement {
    async run(engagementId: number): Promise<Job> {
        const response = await httpRequest<any>(
            `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/network-view/`,
            { method: "POST" }
        );
        return new JobSerializer().deserialize(response);
    }
}
